import "./style.css";
import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import {
  addData,
  addSponserData,
  auth,
  getAllSponsors,
  signInUser,
  signUpUser,
} from "../../utils/firebase-config";
import { INDUSTRY, SPONSER, TEACHER } from "../../utils/constants";
import { useNavigate } from "react-router-dom";

export default function RegistrationSponser(props) {
  const navigate = useNavigate();
  const [sponsers, setSponsers] = useState([]);
  const [formData, setFormData] = useState({
    sponsor_id: "",
    name: "",
    contact_number: "",
    address: "",
    gender: "",
    email: "",
    verified: false,
  });
  const [password, setPassword] = useState({
    password: "",
    confirmPassword: "",
  });
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [newSponsor, setNewSponsor] = useState({
    sponsor_name: "",
    sponsorship_amount: "",
    payment_mode: "",
    payment_receipt: null,
    payment_date: "",
    verified: false,
  });
  const [selectedImage, setSelectedImage] = useState(null);

  const openImage = (imageSrc) => {
    setSelectedImage(imageSrc);
  };

  const closeImage = () => {
    setSelectedImage(null);
  };

  useEffect(() => {
    try {
      getAllSponsors().then((sponsers_data) => {
        setSponsers(sponsers_data);
      });
    } catch (error) {
      console.log(error);
    }
  }, [newSponsor]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPassword({ ...password, [name]: value });
  };

  const handleNewSponsorChange = (e) => {
    const { name, value } = e.target;
    setNewSponsor({ ...newSponsor, [name]: value });
  };

  const handleFileChange = (e) => {
    setNewSponsor({ ...newSponsor, payment_receipt: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      password.password.trim() === "" ||
      password.confirmPassword.trim() === ""
    ) {
      window.alert("Error: Please fill in all the required fields.");
      return;
    }
    if (password.password.trim() !== password.confirmPassword.trim()) {
      window.alert("Password and confirm Password should be the same.");
      return;
    }

    let registrationForm = formData;
    registrationForm.type = SPONSER;

    props.loadingStatus(true);
    const user = await signUpUser(registrationForm.email, password.password);

    if (user !== null) {
      await addData(registrationForm);
      window.alert(`You have registered as Sponser.`);
      props.loadingStatus(false);
      navigate("/detail", { state: registrationForm });
    } else {
      props.loadingStatus(false);
    }
  };

  const handleAddSponsor = async () => {
    try {
      // Await the addSponserData function to ensure it completes before closing the dialog
      await addSponserData(newSponsor);

      // Close the dialog on successful submission
      setDialogOpen(false);

      // Reset the form after adding
      setNewSponsor({
        sponsor_name: "",
        sponsorship_amount: "",
        payment_mode: "",
        payment_receipt: null,
        payment_date: "",
      });

      window.alert(
        "Sponsor added successfully! Now You can select Sponser Name from Dropdown"
      );
    } catch (error) {
      // Display error message if there's an issue
      window.alert(`Error while adding sponsor: ${error.message}`);
    }
  };

  return (
    <>
      {/* Sponsor Registration Form */}
      <form className="registration-form-div" onSubmit={handleSubmit}>
        <div className="form-login">
          <div className="input-field">
            <label>Sponsor Name</label>
            <select
              className="form-input"
              name="sponsor_id"
              value={formData.sponsor_id}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Sponsor</option>
              {sponsers.map((sponsor) => (
                <option key={sponsor.id} value={sponsor.id}>
                  {sponsor.sponsor_name}
                </option>
              ))}
            </select>
            <a href="#" onClick={() => setDialogOpen(true)}>
              Add New Sponsor
            </a>
          </div>

          {/* Remaining Fields */}
          <div className="input-field">
            <label>Person Name</label>
            <input
              className="form-input"
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="input-field">
            <label>Contact Number</label>
            <input
              className="form-input"
              type="tel"
              name="contact_number"
              value={formData.contact_number}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="input-field">
            <label>Address</label>
            <input
              className="form-input"
              type="text"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="input-field">
            <label>Gender</label>
            <select
              className="form-input"
              name="gender"
              value={formData.gender}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
            </select>
          </div>

          <div className="input-field">
            <label>Email</label>
            <input
              className="form-input"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="input-field">
            <label>Password</label>
            <input
              className="form-input"
              type="password"
              name="password"
              value={password.password}
              onChange={handlePasswordChange}
              required
            />
          </div>

          <div className="input-field">
            <label>Confirm Password</label>
            <input
              className="form-input"
              type="password"
              name="confirmPassword"
              value={password.confirmPassword}
              onChange={handlePasswordChange}
              required
            />
          </div>
        </div>

        <button className="submit-btn" type="submit">
          Register
        </button>
      </form>

      <Dialog
        sx={{ "& .MuiDialog-paper": { width: "100%", maxHeight: 800 } }}
        maxWidth="md"
        open={isDialogOpen}
        onClose={() => {
          setDialogOpen(false);
        }}
        style={{ overflowY: "auto" }}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>Add New Sponsor</DialogTitle>
        <DialogContent dividers>
          <div
            className="form-login"
            style={{
              padding: "0",
              backgroundColor: "transparent",
              margin: "0px",
              boxShadow: "0px 0px 0px 0px transparent",
            }}
          >
            <div className="input-field">
              <label>Sponsor Name</label>
              <input
                className="form-input"
                type="text"
                name="sponsor_name"
                value={newSponsor.sponsor_name}
                onChange={handleNewSponsorChange}
                required
              />
            </div>
            <div className="input-field">
              <label>Sponsorship Amount</label>
              <input
                className="form-input"
                type="number"
                name="sponsorship_amount"
                value={newSponsor.sponsorship_amount}
                onChange={handleNewSponsorChange}
                required
              />
            </div>
            <div className="input-field">
              <label>Payment Mode</label>
              <select
                className="form-input"
                name="payment_mode"
                value={newSponsor.payment_mode}
                onChange={handleNewSponsorChange}
                required
              >
                <option value="">Select Payment Mode</option>
                <option value="Bank Transfer">Bank Transfer</option>
                <option value="Check">Check</option>
                <option value="Online">Online</option>
              </select>
            </div>
            <div className="input-field">
              <label>Payment Receipt Image</label>
              <input
                className="form-input"
                type="file"
                name="payment_receipt"
                onChange={handleFileChange}
                accept="image/*"
                required
              />
            </div>
            <div className="input-field">
              <label>Payment Date</label>
              <input
                className="form-input"
                type="date"
                name="payment_date"
                value={newSponsor.payment_date}
                onChange={handleNewSponsorChange}
                required
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              gap: "10px",
              width: "100%",
            }}
          >
            <img
              src="image/11ab11e0.jpeg"
              style={{ width: "50%", objectFit: "contain", cursor: "pointer" }}
              onClick={() => openImage("image/11ab11e0.jpeg")}
              alt="Image 1"
            />
            <img
              src="image/q-r-code-iitd-3dgem.jpg"
              style={{ width: "50%", objectFit: "contain", cursor: "pointer" }}
              onClick={() => openImage("image/q-r-code-iitd-3dgem.jpg")}
              alt="QR Code"
            />
          </div>
          <div className="modal-buttons">
            <button className="submit-btn" onClick={handleAddSponsor}>
              Add Sponsor
            </button>
            <button className="cancel-btn" onClick={() => setDialogOpen(false)}>
              Cancel
            </button>
          </div>
        </DialogContent>
      </Dialog>
      <Dialog
        sx={{ "& .MuiDialog-paper": { width: "100%", maxHeight: 800 } }}
        maxWidth="md"
        open={selectedImage != null}
        onClose={() => {
          setSelectedImage(null);
        }}
        style={{ overflowY: "auto" }}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent dividers>
          <img
            src={selectedImage}
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              objectFit: "contain",
            }}
            alt="Preview"
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
